import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { Link } from 'react-router-dom'
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ticon1 from "../../../images/icon/flower-icon-blue.svg";
import tImg1 from "../../../images/testimonial/da-tes-img.png";
import tImg2 from "../../../images/testimonial/ixico-logo.png";



const Testimonial = () => {

    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current && prevRef.current && nextRef.current) {
            swiperRef.current.params.navigation.prevEl = prevRef.current;
            swiperRef.current.params.navigation.nextEl = nextRef.current;
            swiperRef.current.navigation.init();
            swiperRef.current.navigation.update();
        }
    }, []);

    const ClickHandler = (e) => {
        if (e) e.preventDefault();
    }

    return (
        <section className="testimonial pt-150 pb-140">
            <div className="container">
                <div className="da-sec-titlte text-center mb-60">
                    <span className="sub_title"><span><img src={ticon1} alt="" /></span>Our Services</span>
                    <h2 className="title">What we do</h2>
                </div>
                <div className="da-testimonial-wrap pos-rel">
                    <div className="da-testimonial-slider swiper-container">
                        <div className="swiper-wrapper">
                            <Swiper
                                // install Swiper modules
                                modules={[Navigation]}
                                spaceBetween={50}
                                slidesPerView={1}
                                loop={true}
                                speed={1800}
                                parallax={true}
                                ref={swiperRef}
                                onBeforeInit={(swiper) => {
                                    swiperRef.current = swiper;
                                }}
                            >
                                {[
                                    {
                                        title: "Mobile Apps",
                                        desc: "iOS & Android — native and cross-platform.",
                                        detail1: "Native Performance",
                                        detail1Text: "High performance & smooth UI for maximum engagement.",
                                        detail2: "Cross-platform",
                                        detail2Text: "Reach both iOS and Android users simultaneously.",
                                        img: "/web-designer-background-int.jpg"
                                    },
                                    {
                                        title: "Backend",
                                        desc: "APIs, microservices, and cloud infrastructure at scale.",
                                        detail1: "Scalable APIs",
                                        detail1Text: "Robust and secure microservices architecture.",
                                        detail2: "Cloud Infrastructure",
                                        detail2Text: "Deployed on leading cloud platforms for reliability.",
                                        img: "/IT-management.jpg"
                                    },
                                    {
                                        title: "Web Apps",
                                        desc: "Consumer products, dashboards, and internal tooling.",
                                        detail1: "Premium UI/UX",
                                        detail1Text: "Beautifully crafted user interfaces that delight.",
                                        detail2: "Internal Tooling",
                                        detail2Text: "Streamline your business operations efficiently.",
                                        img: "/crm-development-services.webp"
                                    },
                                    {
                                        title: "AI & Automation",
                                        desc: "LLM integration, voice pipelines, and intelligent automation.",
                                        detail1: "LLM Integration",
                                        detail1Text: "Custom AI models and seamless ChatGPT integrations.",
                                        detail2: "Intelligent Pipelines",
                                        detail2Text: "Voice pipelines and deep workflow automation.",
                                        img: "/securing-against.jpg"
                                    }
                                ].map((service, index) => (
                                    <SwiperSlide className="da-testimonial" key={index}>
                                        <div className="row align-items-center mt-none-30">
                                            <div className="col-lg-6 mt-30">
                                                <div className="da-tes-left">
                                                    <h2 className="xb-item--title">{service.title}</h2>
                                                    <p className="xb-item--content content--one">{service.desc}</p>
                                                    <div className="xb-item--holder ul_li align-items-start">
                                                        <div className="xb-item--meta">
                                                            <h3 className="xb-item--number" style={{fontSize: '24px'}}>{service.detail1}</h3>
                                                            <span className="xb-item--text">{service.detail1Text}</span>
                                                        </div>
                                                        <div className="xb-item--meta">
                                                            <h3 className="xb-item--number" style={{fontSize: '24px'}}>{service.detail2}</h3>
                                                            <span className="xb-item--text">{service.detail2Text}</span>
                                                        </div>
                                                    </div>
                                                    <p className="xb-item--content content--two">We build software for those who think differently.</p>
                                                    <p className="xb-item--content content--three">From Australia to the world — a small, precise team crafting products and platforms that last.</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 mt-30">
                                                <div className="da-tes-right">
                                                    <div className="xb-item--author" style={{borderRadius: '16px', overflow: 'hidden'}}>
                                                        <img src={service.img} alt={service.title} style={{width: '100%', height: '500px', objectFit: 'cover'}} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                    <div className="da-swiper-btn swiper-button-prev" ref={prevRef}><i className="fal fa-long-arrow-left"></i></div>
                    <div className="da-swiper-btn swiper-button-next" ref={nextRef}><i className="fal fa-long-arrow-right"></i></div>
                </div>
                <div className="xb-btn text-center mt-55">
                    <Link onClick={ClickHandler} to="/contact" className="thm-btn thm-btn--fill_icon thm-btn--data thm-btn--data-strock">
                        <div className="xb-item--hidden"><span className="xb-item--hidden-text">Start a conversation</span></div>
                        <div className="xb-item--holder">
                            <span className="xb-item--text xb-item--text1">Start a conversation</span>
                            <div className="xb-item--icon"><i className="fal fa-plus"></i></div>
                            <span className="xb-item--text xb-item--text2">Start a conversation</span>
                        </div>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Testimonial;
